{
  "version": 1,
  "asset_id": "39a284cd-da2d-4fcd-a9d8-e46357b8623e",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/39a284cd-da2d-4fcd-a9d8-e46357b8623e/towing-card.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/39a284cd-da2d-4fcd-a9d8-e46357b8623e/towing-card.webp",
  "original_filename": "towing-card.webp",
  "size": 16382,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:44Z"
}
